<template>
  <div class="home">
    <div class="swiper-box" :class="getSetting.isFull? 'full': 'swiper-h container'" v-if="swiperList.length>0">
      <swiper v-if="swiperList" :options="swiperOption">
        <swiper-slide v-for="(item, index) in swiperList" :key="index">
          <a :href="item.pageUrl" target="_blank">
            <img :src="item.imgUrl" :alt="item.name" class="swiper-img" />
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="search-box">
      <div class="container">
        <div class="height-search-info">
          <div class="left">
            <div class="left_title">{{ $hs("综合查询搜索","Search by Description",'Búsqueda por descripción') }}</div>
            <div class="form-box">
              <div class="form-info">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right" label-width="126px" class="demo-ruleForm">
                  <el-form-item :label="$hs('种类','Category')" prop="cl_Nu">
                    <div style="display: flex;align-items: center;width: 75%;justify-content: space-between;">
                      <el-select
                        style="width:175px;"
                        v-model="ruleForm.cl_Nu"
                        clearable
                        filterable
                        :placeholder="$t('GA.PleaseSelect')"
                        @change="clNuChange"
                      >
                        <el-option
                          v-for="(item, index) in options"
                          :key="index"
                          :label="item[$hs('cl_Na','cl_Ne_Na','threeLanguage')]"
                          :value="item.cl_Nu"
                        >{{ item[$hs('cl_Na','cl_Ne_Na','threeLanguage')] }}</el-option>
                      </el-select>
                      <div style="display: flex;">
                        <div style="margin-right: 10px;">{{$hs('包装方式','Packing','Forma de embalaje')}}:</div>
                        <el-select
                          style="width:175px;"
                          v-model="ruleForm.packMethod"
                          clearable
                          filterable
                          :placeholder="$t('GA.PleaseSelect')"
                        >
                          <el-option
                            v-for="(item, index) in setPackwebList"
                            :key="index"
                            :label="item[$hs('ch_Pa','en_Pa','threeLanguage')]"
                            :value="item.pa_Nu"
                          >{{ item[$hs('ch_Pa','en_Pa','threeLanguage')] }}</el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$hs('产品名称','Description')" prop="pr_Na">
                    <div style="width: 75%;display: flex;">
                      <el-input :placeholder="$t('GA.PleaseEnterTheProductNameKeyword')" v-model="ruleForm.pr_Na" style="width: 485px;"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('GA.Size')">
                    <div class="sizeBar" style="display: flex;width: 75%;">
                      <div style="display: flex;">
                        <span style="margin-right: 11px;">L</span>
                        <el-input type="text" v-model="ruleForm.pr_Le" :placeholder="$t('GA.PleaseLength')" style="width: 112px;"></el-input>
                      </div>
                      <div style="display: flex;margin-left: 30px;">
                        <span style="margin-right: 11px;">W</span>
                        <el-input type="text" v-model="ruleForm.pr_Wi" :placeholder="$t('GA.PleaseWidth')" style="width: 112px;"></el-input>
                      </div>
                      <div style="display: flex;margin-left: 30px;">
                        <span style="margin-right: 11px;">H</span>
                        <el-input type="text" v-model="ruleForm.pr_Hi" :placeholder="$t('GA.PleaseHeight')" style="width: 112px;"></el-input>
                      </div>
                    </div>
                  </el-form-item>

                  <el-form-item :label="$t('GA.Price')">
                    <div style="display: flex;align-items: center;width: 75%;">
                      <el-input type="text" v-model="ruleForm.price1" :placeholder="$t('GA.PleaseMinPrice')" style="width:225px;"></el-input>
                      <span style="margin: 0 15px;">-</span>
                      <el-input type="text" v-model="ruleForm.price2" :placeholder="$t('GA.PleaseMaxPrice')" style="width:225px;"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$hs('外箱装量','Quantity/carton')">
                    <div style="display: flex;align-items: center;width: 75%;">
                      <el-input
                        type="text"
                        v-model="ruleForm.ou_Lo1"
                        :placeholder="$hs('请输入最小外箱装量','Please specify the quantity of the outer box.','')"
                        style="width:225px;"
                      ></el-input>
                      <span style="margin: 0 15px;">-</span>
                      <el-input
                        type="text"
                        v-model="ruleForm.ou_Lo2"
                        :placeholder="$hs('请输入最大外箱装量','Please specify the quantity of the outer box.','')"
                        style="width:225px;"
                      ></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('GA.Date')">
                    <div style="display: flex;align-items: center;width: 75%;">
                      <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        v-model="ruleForm.date1"
                        style="width:225px;"
                        :placeholder="$t('GA.PleaseStartDate')"
                      ></el-date-picker>
                      <span style="margin: 0 15px;">-</span>
                      <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        v-model="ruleForm.date2"
                        style="width: 225px;"
                        :placeholder="$t('GA.PleaseEndDate')"
                      ></el-date-picker>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div class="form-btn">
                <div class="search" @click="submitForm">{{$t('GA.Search')}}</div>
                <div class="reset" @click="resetForm">{{$t('GA.Reset')}}</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="right_title">{{ $hs("按公司编号搜索","Multi-Item Search") }}</div>

            <div class="more-box">
              <div>
                <el-input
                  type="textarea"
                  style="height: 294px;"
                  v-model="codeForm.itemNoValue"
                  :autosize="{ minRows: 9, maxRows: 9}"
                  :placeholder="$hs(`请同时输入多个号码进行搜索。
请使用','分隔。例如:lf00001,1f00002,1f00003`,`Please enter multiple numbers to search at the same time.
Please use ',' to separate.For example lf00001,
1f00002,1f00003
                  `)"
                ></el-input>
              </div>
              <div class="more-btn">
                <div class="search" @click="moreProductNo">{{$t('GA.Search')}}</div>
                <div class="search reset" @click="moreProdutReset">{{$t('GA.Reset')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="our_catalogue">
      <div class="container">
        <div class="title">{{$hs('我的目录','Our Catalogue')}}</div>
        <div class="our_catalogueBox">
          <div class="our_catalogueItems" v-for="(items, index) in options" :key="index" @click="classChange(items,index)">
            <span style="margin-left: 20px;">{{ items[$hs('cl_Na','cl_Ne_Na','threeLanguage')] }}</span>
            <span class="counts">[{{ items['count'] }}]</span>
          </div>
          <!-- 补齐当前行所剩下的单元格 -->
          <div class="our_catalogueItemsnot" v-for="(items,index) in 4-(options.length%4)" :key="`${index}-copy`"></div>
        </div>
      </div>
    </div>
    <div class="new-product">
      <new-product></new-product>
    </div>
    <div>
      <div class="container hot-pro">
        <div class="tit-box">
          <div class="tit">{{$t('GA.hotPro')}}</div>
          <div class="right-box">
            <div class="more" @click="recommendClick">
              {{$hs("查看更多","View More",'')}}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="products">
          <div class="cell" v-for="(item, index) in recommendList" :key="index">
            <everyProduct :productData="item"></everyProduct>
          </div>
          <div class="empty" v-if="recommendList.length<=0">
            <el-empty :description="$hs('暂无数据','There is currently no data available','No hay datos por el momento')"></el-empty>
          </div>
        </div>
      </div>
    </div>

    <div class="cooperative_partner">
      <div class="container partner">
        <div class="cooperative_title">{{ $hs('合作伙伴','Cooperative Partner','') }}</div>
        <div class="cooperative_images" @mouseenter="stopAnimation" @mouseleave="startAnimation" v-if="mfrsLogoList.length>5">
          <div class="cooperative_images_wrapper" ref="wrapper">
            <div class="images_wrapper" v-for="(items, index) in mfrsLogoList" :key="index">
              <img :src="items.ma_Logo" alt />
            </div>
            <div class="images_wrapper" v-for="(items, index) in mfrsLogoList" :key="`${index}-copy`">
              <img :src="items.ma_Logo" alt />
            </div>
          </div>
        </div>
        <div class="cooperative_images" v-else>
          <div class="cooperative_images_wrapper1" ref="wrapper">
            <div class="images_wrapper" v-for="items in mfrsLogoList" :key="items.id">
              <img :src="items.ma_Logo" alt />
            </div>
          </div>
        </div>
        <div class="viewMore" @click="showProduct">
          {{ $hs("查看更多","View More",'') }}
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="videoDialog">
      <el-dialog :title="$t('GA.Video_playback')" :visible.sync="dialogVisible" :before-close="handleClose">
        <span>
          <video ref="videoPlayer" :src="videoUrl" type="video/mp4" style="max-height:580px;max-width:100%" controls autoplay></video>
        </span>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  CarouselGetList,
  ProductClassWebGetTree,
  VideoGetList,
  ProductClassRecommendWebGetList,
  ProductPackWebGetList,
  ProductClassWebGetProductCountByClass,
  BrandRecommendationWebGetList
} from '@/api/home'
import { GetProductListByDiscount } from '@/api/home'
import { VideoGetCategoryList } from '@/api/vidio'
import { insertHomeView } from '@/api/statistics'
import { mapState, mapGetters } from 'vuex'

import newProduct from '@/components/productBox/newProduct.vue'

import everyProduct from '@/components/productBox/everyProduct.vue' //单个产品组件
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import transformMark from '@/utils/water'
export default {
  name: 'homePage',
  components: {
    swiper,
    swiperSlide,
    newProduct,
    everyProduct
  },
  data: () => ({
    swiperOption: {
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 显示分页
      pagination: {
        el: '.swiper-pagination',
        clickable: true //允许分页点击跳转
      }
    },
    swiperList: [],
    setPackwebList: [],
    recommendList: [],
    dialogVisible: false,
    videoUrl: '',
    videoList: [],
    setMenusData: [],
    setMenus: [],
    options: [],
    optionsChildren: [],
    mfrsLogoList: [],
    activeName: '',
    ruleForm: {
      pr_Na: '',
      itemNo: 'co_Nu',
      itemNoValue: '',
      date1: '',
      date2: '',
      cl_Nu: '',
      packMethod: '',
      price1: '',
      ou_Lo1: '',
      ou_Lo2: '',
      price2: '',
      pr_Le: '',
      pr_Wi: '',
      pr_Hi: '',
      sort: 'dateDESC'
    },
    rules: {},
    codeForm: {
      itemNo: 'co_Nu',
      itemNoValue: ''
    }
  }),
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters('setting', {
      getSetting: 'get_setting'
    }),
    ...mapGetters('operate', {
      getEnquiry: 'get_enquiry'
    })
  },
  created() {
    this.initData()
    this.getRecommendPro()
    // this.getCategoryVidio()
    this.statisticsView()
    this.startAnimation()
  },
  methods: {
    stopAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = 'paused'
        }
      })
    },
    startAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = 'running'
        }
      })
    },
    // 统计访问
    statisticsView() {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || ''
        }
        insertHomeView(obj).then(() => { })
      }
    },
    recommendClick() {
      this.$router.push({
        path: '/recommendPro'
      })
    },
    initData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      BrandRecommendationWebGetList({
        num: 1000
      }).then(res => {
        if (res.success) {
          this.mfrsLogoList = res.data
        }
      })

      ProductClassWebGetProductCountByClass().then(res => {
        if (res.success) {
          this.options = res.data
        }
      }).catch(err => {
        this.$message.error(err)
      })

      // 首页轮播
      CarouselGetList()
        .then(res => {
          if (res.success) {
            this.swiperList = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })

      ProductPackWebGetList().then(res => {
        if (res.success) {
          this.setPackwebList = res.data
        }
      }).catch(err => {
        this.$message({ err })
      })
        .finally(() => {
          loading.close()
        })

    },

    getCategoryVidio() {
      VideoGetCategoryList()
        .then(res => {
          if (res.success) {
            let categoryList = res.data || []
            this.getVidioList(categoryList)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },

    getVidioList(categoryList) {
      this.videoList = []
      for (let i = 0; i < categoryList.length; i++) {
        // 视频
        const model = {
          videoCategoryId: categoryList[i].id
        }
        VideoGetList(model)
          .then(res => {
            if (res.success) {
              let vidioList = res.data || []
              vidioList = vidioList.slice(0, 6)
              this.videoList.push({ ...categoryList[i], list: vidioList })
            } else {
              this.$message.error(res.message)


            }
          })
          .catch(err => {
            this.$message.error(err)
          })
      }
    },
    classChange(items, index) {
      this.ruleForm.cl_Nu = items.cl_Nu
      // this.$router.push({
      //   name: 'product',
      //   params: {
      //     clNu: items.cl_Nu
      //   }
      // })
      window.open(`/#/product?clNu=${items.cl_Nu}`, '_blank')

    },
    // 关闭视频
    handleClose(done) {
      done()
      this.videoUrl = ''
    },
    // 点击播放icon
    playClick(videoUrl) {
      this.videoUrl = videoUrl
      this.dialogVisible = true
    },

    goVidioMore(videoData) {
      this.$router.push({
        path: 'video',
        query: {
          id: videoData.id,
          zhTit: videoData.categoryName,
          enTit: videoData.categoryEnName,
          esTit: videoData.categoryOtherName
        }
      })
    },

    getRecommendPro(clNu) {
      const data = {
        client_Nu: this.userInfo.client_Nu || '',
        category: 0, // 0推荐 1热销  2折扣
        num: 12,
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 推荐产品
      GetProductListByDiscount(data)
        .then(res => {
          if (res.success) {
            this.recommendList = res.data.map(item => {
              const ind = this.getEnquiry[0].list.findIndex(
                it => it.co_Nu === item.co_Nu
              )
              if (ind > -1) {
                return { ...item, _num_: true }
              }
              return { ...item, _num_: false }
            })

            this.recommendList.forEach(item => {
              transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(
                result => {
                  item.imgUrl = result
                }
              )
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          loading.close()
        })
    },
    submitForm() {
      this.$router.push({
        name: 'product',
        params: {
          ruleForm: this.ruleForm
        }
      })
    },

    resetForm() {
      this.ruleForm = {
        pr_Na: '',
        itemNo: 'co_Nu',
        itemNoValue: '',
        date1: '',
        date2: '',
        cl_Nu: '',
        packMethod: '',
        price1: '',
        price2: '',
        ou_Lo1: '',
        ou_Lo2: '',
        pr_Le: '',
        pr_Wi: '',
        pr_Hi: '',
        sort: 'dateDESC'
      }
    },
    showProduct() {
      this.$router.push({
        path: '/brand'
      })
    },
    handleClick(e) {
      this.getHotPro(e.name)
    },

    clNuChange(val) {
      this.options.forEach(item => {
        if (item.cl_Nu === val) {
          this.optionsChildren = item.children
          this.ruleForm.packMethod = ''
        }
      })
    },

    optionFun() {
      this.options = this.setMenus
      this.optionsChildren = []
    },

    moreProductNo() {
      this.$router.push({
        name: 'product',
        params: { codeForm: this.codeForm }
      })
      this.$bus.$emit('moreProductNo', this.codeForm)
    },
    moreProdutReset() {
      this.codeForm = {
        itemNo: 'co_Nu',
        itemNoValue: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.full {
  width: 100%;
}

.cooperative_partner {
  background: #eaedf0;
  .partner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .cooperative_title {
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    color: #222222;
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .cooperative_images {
    width: 1200px;
    height: 190px;
    overflow: hidden;
    position: relative;
    .cooperative_images_wrapper {
      display: flex;
      align-items: center;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      white-space: nowrap;
      animation: carousel 30s linear infinite;
    }
    .cooperative_images_wrapper1 {
      display: flex;
      align-items: center;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      white-space: nowrap;
    }
    .images_wrapper {
      width: 190px;
      height: 120px;
      margin-right: 10px;
      display: flex;
      background-color: #fff;
      img {
        max-width: 190px;
        max-height: 120px;
        margin: 0 auto;
      }
    }

    @keyframes carousel {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(-50%);
      }
    }
  }
  .viewMore {
    width: 137px;
    height: 34px;
    background: #f20000;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    line-height: 34px;
    text-align: center;
    margin-bottom: 50px;
    cursor: pointer;
  }
}

.swiper-box.swiper-h {
  min-height: 450px !important;
  max-height: 450px !important;
  .swiper-img {
    width: 100%;
    min-height: 450px !important;
    max-height: 450px !important;
  }
}

.container {
  margin-top: 10px;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper-box {
  max-height: 450px;
  overflow: hidden;
  margin-top: 0 !important;

  .swiper-img {
    &:hover {
      cursor: pointer;
    }
  }

  :deep(.swiper-pagination-bullet-active) {
    background-color: #fca81e;
  }
}

.new-product {
  background-color: #fff;
}
.video-center {
  background-color: #f5f5f5;
}
.weixin {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 100%;
  }
}
.side-fixed {
  position: fixed;
  top: 400px;
  right: 0px;
  // background-color: #eee;
  .btn {
    width: 48px;
    height: 48px;
    background-color: #eba61a;
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background-color: #ffaa00;
      color: #f5f5f5;
    }
    :deep .el-popover__reference-wrapper {
      width: 100%;
      height: 100%;
      .el-popover__reference {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.hot-pro {
  margin-top: 20px;
  .tit-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
    background: #ff0000;
    padding: 0 30px;
    color: #ffffff;
    .tit {
      flex: 1;
      height: 54px;
      font-size: 16px;
      font-weight: 700;
      text-align: left;

      line-height: 54px;
    }

    .right-box .more {
      cursor: pointer;
      &:hover {
        color: #ffdcdc;
      }
    }
  }
  .title {
    width: 100%;
    height: 54px;
    line-height: 54px;
    background: #ff0000;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    padding-left: 30px;
  }

  .category {
    height: 56px;
    border-bottom: 4px solid #f2410f;
    margin: 10px 0 30px;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16) inset;
    border-radius: 20px 20px 0 0;
    box-sizing: border-box;
    overflow: hidden;
    :deep .el-tabs__header {
      margin: 0 !important;
      .el-tabs__item {
        height: 55px;
        line-height: 55px;
        padding: 0 20px;
        font-size: 14px;
        border: 0 !important;
        overflow: hidden;
        &:hover {
          background-color: #f2410f;
          color: #fff;
        }
        &.is-active {
          background-color: #f2410f;
          color: #fff;
        }
      }
    }
    :deep .el-tabs__nav-wrap.is-scrollable {
      padding: 0 30px !important;
      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        width: 30px;
        height: 100%;
        background-color: #eee;
        text-align: center;
        line-height: 55px;
        font-size: 22px;
        &:hover {
          color: #f2410f;
        }
      }
    }
  }
  .products {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    .cell {
      width: 180px;
      height: 280px;
      margin-right: 24px;
      margin-bottom: 24px;
      box-sizing: border-box;
      &:nth-child(6n) {
        margin-right: 0;
      }
    }
    .empty {
      height: 364px;
      margin: auto;
    }
  }
}
.mode {
  display: flex;
  justify-content: center;
  .btn-mode {
    width: 200px;
    height: 46px;
    background: #ff6000;
    border-radius: 23px;
    color: #fff;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }
}

.search-box {
  background-color: #fff;

  .title {
    font-size: 50px;
    font-weight: 700;
    color: #333c4f;
    padding: 30px 0 0;
  }
  .height-search-info {
    display: flex;
    box-sizing: border-box;
    font-size: 13px;
    color: #828282;
    padding-top: 50px;
    .left {
      width: 750px;
      .left_title {
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 37px;
        text-align: center;
        color: #222222;
      }
      .el-radio {
        margin: 0 10px 0 0;
        .el-radio__label {
          font-size: 13px !important;
        }
      }

      .form-box {
        :deep(.el-form-item) {
          margin: 12px 0 0 0 !important;
          .el-form-item__label,
          .el-form-item__content {
            line-height: 36px;
            padding: 0px !important;
            margin-right: 10px;
          }
          .el-form-item__label::after {
            content: ':';
          }
        }
        .form-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 27px;
          margin-bottom: 50px;
          & > div {
            width: 120px;
            height: 46px;
            line-height: 45px;
            border-radius: 50%;
            text-align: center;
            color: #fff;
            margin: 0 20px 0 0;
            font-size: 16px;
            cursor: pointer;
          }

          .search {
            width: 106px;
            height: 34px;
            line-height: 34px;
            background: #f20000;
            border-radius: 4px;
          }

          .reset {
            width: 106px;
            height: 34px;
            line-height: 34px;
            background: #bfbfbf;
            border-radius: 4px;
          }
        }
      }
    }
    .right {
      flex: 1;
      .right_title {
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 37px;
        text-align: center;
        color: #222222;
      }
      .more-title {
        height: 35px;
        // line-height: 34px;
        padding: 6px 0 0 0;
        color: #222222;
        font-weight: bold;
        text-align: center;
        box-sizing: border-box;
      }
      :deep(.el-textarea__inner) {
        height: 100% !important;
      }

      .more-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 27px;
        & > div {
          width: 180px;
          height: 46px;
          line-height: 45px;
          border-radius: 50%;
          text-align: center;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
        }

        .search {
          width: 106px;
          height: 34px;
          line-height: 34px;
          background: #f20000;
          border-radius: 4px;
        }

        .reset {
          background: #bfbfbf;
          margin-left: 30px;
        }
      }
    }
  }
}

.our_catalogue {
  .container {
    margin-top: 0 !important;
  }
  .title {
    width: 100%;
    height: 54px;
    background: #ff0000;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    color: #fffefe;
    line-height: 54px;
  }
  .our_catalogueBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    border: 1px solid #ff0000;
    border-right: none;
    .our_catalogueItems {
      width: 298.5px;
      height: 36px;
      line-height: 36px;
      border: 1px solid #ff0000;
      font-size: 12px;
      font-weight: normal;
      text-align: left;
      color: #222222;
      overflow: hidden;
      cursor: pointer;
      .counts {
        color: #ff0000;
      }
      &:nth-child(n) {
        border-left: none;
        border-bottom: none;
      }
      &:hover {
        background-color: #ff0000;
        color: #fff !important;
        .counts {
          color: #fff !important;
        }
      }
    }
    .our_catalogueItemsnot {
      width: 298.5px;
      height: 36px;
      line-height: 36px;
      border: 1px solid #ff0000;
      border-left: none;
      border-bottom: none;
    }
  }
}

:deep .el-dialog__body {
  max-height: 670px;
  display: flex;
  justify-content: center;
  align-content: center;
  background-color: #000;
  padding: 0 !important;
  margin: 0 20px;
}
:deep .el-radio__label {
  font-size: 14px !important;
  padding-left: 4px !important;
}
</style>